// Mobile menu toggle
(function () {
    const button = document.getElementById('mobile-menu-btn');
    const menu = document.getElementById('mobile-menu');
    const openIcon = document.getElementById('mobile-menu-open-icon');
    const closeIcon = document.getElementById('mobile-menu-close-icon');

    if (!button || !menu || !openIcon || !closeIcon) {
        return;
    }

    button.addEventListener('click', function () {
        const isHidden = menu.classList.contains('hidden');
        menu.classList.toggle('hidden');
        openIcon.classList.toggle('hidden', !isHidden);
        closeIcon.classList.toggle('hidden', isHidden);
        button.setAttribute('aria-expanded', String(isHidden));
    });
})();

// Avatar dropdown toggle
(function () {
    const avatarBtn = document.getElementById('avatar-btn');
    const dropdown = document.getElementById('avatar-dropdown');

    if (!avatarBtn || !dropdown) {
        return;
    }

    function openDropdown() {
        dropdown.classList.remove('hidden');
        avatarBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
        dropdown.classList.add('hidden');
        avatarBtn.setAttribute('aria-expanded', 'false');
    }

    avatarBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (dropdown.classList.contains('hidden')) {
            openDropdown();
        } else {
            closeDropdown();
        }
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target) && e.target !== avatarBtn) {
            closeDropdown();
        }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeDropdown();
            avatarBtn.focus();
        }
    });
})();
